import { useEffect, useState } from 'react';

/** How long typing has to pause before a search runs: short enough to feel immediate. */
export const SEARCH_DEBOUNCE_MS = 200;

/**
 * A value that follows another a moment later, once it has stopped changing.
 * For a search box: the field shows every keystroke at once, and the list is
 * filtered when the typing pauses rather than on each letter. Request of
 * 5 October 2026, section 3.
 *
 * Clearing is not delayed: an emptied search shows everything again at once.
 */
export function useDebouncedValue(value: string, delayMs: number = SEARCH_DEBOUNCE_MS): string {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    if (value === '') {
      setSettled('');
      return;
    }
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return value === '' ? '' : settled;
}
